/** @format */

import { Injectable } from '@angular/core';
import { map as lmap } from 'lodash-es';
import { ModelMapper } from 'model-mapper';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { IQuotationFilter, Quotation, QuotationService as SesioQuotationService } from 'sesio-lib';
import { IDatatableOptions, IDatatableRecords } from '../_components/datagrid/datatable.class';

@Injectable({
  providedIn: 'root',
})
export class QuotationService extends SesioQuotationService {
  public list({ realEstateStructureIds }: { realEstateStructureIds?: string[] }): Observable<Quotation[]> {
    const params: any = {};
    if (realEstateStructureIds?.length) {
      params.realEstateStructureIds = realEstateStructureIds;
    }
    return this.http
      .get<any[]>(`${this.config.environment.apiUrl}/quotations`, { params })
      .pipe(map(data => lmap(data, d => new ModelMapper(Quotation).map(d))));
  }

  public getStatus(search?: IQuotationFilter): Observable<{ name: string; value: number }[]> {
    return this.http.post<any>(
      `${this.config.environment.apiUrl}/quotations/get-status`,
      this.buildSearchFilter(search)
    );
  }

  public getOrderStatus(search?: IQuotationFilter): Observable<{ name: string; value: number }[]> {
    return this.http.post<any>(
      `${this.config.environment.apiUrl}/quotations/get-order-status`,
      this.buildSearchFilter(search)
    );
  }

  public datatable(
    query: IDatatableOptions,
    search?: IQuotationFilter,
    box?: number[][]
  ): Observable<IDatatableRecords<any>> {
    const params: any = {};
    if (box?.length) params.box = box;
    return this.http.post<any>(
      `${this.config.environment.apiUrl}/quotations/datatable`,
      { query, filter: this.buildSearchFilter(search) },
      { params }
    );
  }
}
